import { useCallback, useState } from "react";
import type { ReactNode } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions,
  Button,
} from "@mui/material";

type CloseReason = "OK" | "CANCEL";

interface ArticleNumeroBonDeCommandePopupProps {
  open: boolean;
  onClose: (numeroBonDeCommande: string | undefined, reason: CloseReason) => void;
  actualNumeroBonDeCommande?: string;
}

function ArticleNumeroBonDeCommandePopup({
  open,
  onClose,
  actualNumeroBonDeCommande,
}: Readonly<ArticleNumeroBonDeCommandePopupProps>): ReactNode {
  const [numeroBonDeCommande, setNumeroBonDeCommande] = useState<string>(
    actualNumeroBonDeCommande ?? ""
  );

  const sendBonDeCommande = useCallback(() => {
    if (numeroBonDeCommande !== "") {
      onClose(numeroBonDeCommande, "OK");
    }
  }, [numeroBonDeCommande, onClose]);
  const cancel = useCallback(() => {
    onClose(undefined, "CANCEL");
  }, [onClose]);

  return (
    <Dialog open={open} onClose={cancel}>
      <DialogTitle>N° Bon de commande requis</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          required
          fullWidth
          margin="dense"
          label="N° Bon de commande"
          placeholder="4500037812MAG"
          variant="standard"
          value={numeroBonDeCommande}
          onChange={(e) => {
            setNumeroBonDeCommande(e.target.value);
          }}
          error={numeroBonDeCommande === ""}
          onKeyDown={({ key }) => {
            if (key === "Enter") sendBonDeCommande();
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button variant="text" onClick={cancel} color="error">
          Annuler
        </Button>
        <Button variant="contained" onClick={sendBonDeCommande}>
          Valider
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ArticleNumeroBonDeCommandePopup;
